import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { BankDetails } from '../../interfaces/bankDetails';
import { environment } from '../../../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class BsbService {
  private bsbUrl = `${environment.teamSalaryBackendUrl}/bsb-verification`;

  private bsbApiKey = environment.bsbApi_string;

  constructor(private http: HttpClient) { }

  verifyBsb(bsbNumber: string): Observable<BankDetails> {
    const headers = new HttpHeaders({
      'X-Api-Key': this.bsbApiKey
    });

    const url = `${this.bsbUrl}?bsb=${bsbNumber}`;

    return this.http.get<BankDetails>(url, { headers });
  }
}
